import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8182c024"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 bg-white rounded-4 shadow p-0 m-0 mt-5" }
const _hoisted_2 = { class: "m-4" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = {
  key: 0,
  class: "reload-error"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo cursor-pointer fs-3 color-icon" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-error" }, "Error Api", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "m-4"
}
const _hoisted_13 = { class: "group-name" }
const _hoisted_14 = { class: "text-black fs-7" }
const _hoisted_15 = {
  key: 0,
  class: "ms-1 badge bg-green"
}
const _hoisted_16 = { class: "data-number" }
const _hoisted_17 = { class: "data-number" }
const _hoisted_18 = {
  key: 1,
  class: "text-center fw-bold"
}
const _hoisted_19 = { class: "mt-3 d-flex" }
const _hoisted_20 = { class: "d-flex align-items-center ms-3 total-number" }

import { translate } from '@/languages/i18n'
import PaginationModal from '@/components/pagination/paginationContractHistory.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import Table from '@/components/table/DashBoardTable.vue'
import { onMounted, ref, watch } from 'vue'
import communityDashboardService from '@/services/community-dashboard.services'
import { useRoute } from 'vue-router'
import { ConvertYearMonthDay } from '@/constants/datepicker.ts'
import { numberWithCommas } from '@/constants/common.ts'
import _ from 'lodash'


export default /*#__PURE__*/_defineComponent({
  props: {
  date: {
    type: Object,
  },
},
  setup(__props) {

const props = __props


const route = useRoute()
const loading = ref(false)
const errorCallApi = ref(false)
const pageOfNumber = ref(30)
const curPage = ref(1)
const total_pages = ref(1)
const dataListGroup = ref([])
const dataListGroupTotal = ref([])

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

onMounted(() => {
  getDataList()
})

watch(
  () => props.date?.from,
  () => {
    curPage.value = 1
    getDataList()
  }
)
watch(
  () => props.date?.to,
  () => {
    curPage.value = 1
    getDataList()
  }
)
const changeQuery = (query: any): void => {
  pageOfNumber.value = query?.page_of_number
  curPage.value = query?.page
  filterData(pageOfNumber.value, curPage.value)
}

const changeSort = (query: any): void => {
  curPage.value = 1

  // 2022/09/26 PhucNV Fix bug can't sort "Number of participants" and "Number of talk rooms" in "Group 1" table UAT#4486: CB10(Ph2-R20220930)
  dataListGroupTotal.value = _.orderBy(dataListGroupTotal.value, [Object.keys(query)[0], 'created_at'], [Object.values(query)[0], 'asc'])
  filterData(pageOfNumber.value, curPage.value)
}

const getDataList = async () => {
  loading.value = true
  try {
    const res = await communityDashboardService.getGroups(route.params.id, {
      from: props.date?.from ?? '',
      to: props.date?.to ?? '',
    })
    if (res.data?.success) {
      errorCallApi.value = false
      dataListGroupTotal.value = _.orderBy(res?.data.data, ['groups_members_number', 'created_at'], ['desc', 'asc']).map((value, index) => ({
        ...value,
        index: index + 1,
      }))
      filterData(pageOfNumber.value, curPage.value)
    } else {
      errorCallApi.value = true
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    loading.value = false
  }
}

const filterData = (pageNumber: number, currentPage: number) => {
  const dataCurrent = []
  for (let i = 0; i < dataListGroupTotal.value.length; i += parseInt(pageNumber)) {
    dataCurrent.push(dataListGroupTotal.value.slice(i, i + parseInt(pageNumber)))
  }
  total_pages.value = dataCurrent.length
  dataListGroup.value = dataCurrent[currentPage - 1]
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_unref(translate)('CB10titleGroupList')), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      (!loading.value && errorCallApi.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: getDataList,
            class: "reload-error"
          }, _hoisted_11))
        : _createCommentVNode("", true)
    ]),
    (!loading.value && !errorCallApi.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (!loading.value)
            ? (_openBlock(), _createBlock(Table, {
                key: 0,
                columns: [
          { field: 'group_name', name: _unref(translate)('CB10groupName') },
          { field: 'user_name', name: _unref(translate)('CB10Author') },
          { field: 'created_at', name: _unref(translate)('CB10CreatedDate') },
          { field: 'groups_members_number', name: _unref(translate)('CB10NumberParticipants'), sort: _ctx.sortField === 'groups_members_number', classTh: 'class-text-right', activeSort: true },
          { field: 'talkrooms', name: _unref(translate)('CB10NumberTopics'), sort: _ctx.sortField === 'talkrooms', classTh: 'class-text-right' },
        ],
                sortCells: ['groups_members_number', 'talkrooms'],
                onChangeSort: changeSort,
                pageOfNumber: pageOfNumber.value,
                curPage: curPage.value,
                idTable: 'groupTable'
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataListGroup.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass(['align-middle text-center', { rowEven: index % 2 === 0 }])
                    }, [
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item?.group_name), 1),
                        (item?.invitation_group === true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(translate)('inviteOnlyGroup')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item?.user_name), 1),
                      _createElementVNode("td", null, _toDisplayString(_unref(ConvertYearMonthDay)(item?.created_at)), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(numberWithCommas)(item?.groups_members_number)), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(numberWithCommas)(item?.talkrooms)), 1)
                    ], 2))
                  }), 128))
                ]),
                _: 1
              }, 8, ["columns", "pageOfNumber", "curPage"]))
            : _createCommentVNode("", true),
          (dataListGroupTotal.value?.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(translate)('CB10NoData')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(PaginationModal, {
              totalPage: total_pages.value || 1,
              onChangeQuery: changeQuery,
              isNotFilterUrl: true,
              pageOfNumber: pageOfNumber.value,
              curPage: curPage.value
            }, null, 8, ["totalPage", "pageOfNumber", "curPage"]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number',
                onChangeQuery: changeQuery,
                isNotFilterUrl: true,
                pageOfNumber: pageOfNumber.value
              }, null, 8, ["options", "pageOfNumber"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})